<template>
  <el-table-column
    prop="vat"
    label="Áfa"
    show-overflow-tooltip
    align="right"
  >
    <template slot-scope="scope">
      {{ scope.row.vat | currency }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'vat',
};
</script>
